export const FreeAnalysesConfig = {
    defaultCount: 3,
};

/** Calendar month in UTC — matches the monthly Cloud Scheduler reset (1st 00:00 UTC). */
export function startOfUtcMonth(now = Date.now()): number {
    const d = new Date(now);
    return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1);
}

/**
 * Remaining free URL analyses this month.
 * Prefers the stored counter when it is valid, but never shows more remaining
 * than (quota − analyses actually created this month). That repairs a missing
 * or stale `freeAnalysesLeft` after an analysis that was not decremented.
 */
export function remainingFreeAnalyses(
    stored: number | null | undefined,
    usedThisMonth: number,
    max = FreeAnalysesConfig.defaultCount
): number {
    const cap = Math.max(0, max);
    const used = Math.max(0, usedThisMonth);
    const derived = Math.max(0, cap - used);
    if (typeof stored !== 'number' || Number.isNaN(stored) || stored < 0 || stored > cap) {
        return derived;
    }
    return Math.min(stored, derived);
}

export function isAnalyzeArticle(article: { isAnalyze?: boolean }): boolean {
    return !!article.isAnalyze;
}
